import {useMemo, useState} from 'react'
import Select from 'react-select'

const customStyle = {
  control: (base: any) => ({
    ...base,
    '&:hover': {borderColor: '#B5B5C3'},
    border: '1px solid #E4E6EF',
    boxShadow: 'none',
    cursor: 'pointer',
  }),

  valueContainer: (base: any) => ({
    ...base,
    maxHeight: '150px',
    overflowY: 'auto',
  }),

  placeholder: (defaultStyles: any) => ({
    ...defaultStyles,
    color: '#A1A5B7',
  }),

  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
  }),
}

const SelectSearchField = ({
  dynamicListLoading = false,
  value,
  handleOnChange,
  isSearchable,
  options,
  handleInputChange,
  name,
  isLoading,
  loadingMessage,
  noOptionsMessage,
  placeholder,
  selectInputRef,
  multiple = false,
  classNamePrefix,
  id,
  isClearable = true,
  isDisabled = false,
  isOpen = undefined,
  className,
  defaultValue,
  menuPlacement = undefined,
  formatOptionLabel,
  isProjectField = false,
  isClientShowInProject = false,
  isResourceNeedToShow = true,
}: any) => {
  const BATCH_SIZE = 100
  const [batchCount, setBatchCount] = useState(1)

  const batchedOptions = useMemo(() => {
    if (options.length <= BATCH_SIZE) return options
    return options.slice(0, batchCount * BATCH_SIZE)
  }, [options, batchCount])

  const handleScrollBottom = () => {
    if (batchCount * BATCH_SIZE < options.length) {
      setBatchCount((prev) => prev + 1)
    }
  }

  return (
    <Select
      isMulti={multiple}
      ref={selectInputRef || null}
      defaultValue={defaultValue}
      styles={customStyle}
      value={value}
      placeholder={placeholder}
      onChange={(selectedOption: any) => {
        handleOnChange({target: {name, value: selectedOption}})
      }}
      isSearchable={isSearchable}
      onInputChange={handleInputChange}
      getOptionLabel={(option: any) => option.name}
      getOptionValue={(option: any) => option.id}
      options={dynamicListLoading ? batchedOptions : options}
      name={name}
      isLoading={isLoading}
      loadingMessage={() => loadingMessage}
      noOptionsMessage={() => noOptionsMessage}
      isClearable={isClearable}
      classNamePrefix={classNamePrefix}
      id={id}
      isDisabled={isDisabled}
      menuIsOpen={isOpen}
      className={className || ''}
      menuPlacement={menuPlacement}
      {...(dynamicListLoading && {
        onMenuScrollToBottom: handleScrollBottom,
      })}
      formatOptionLabel={
        isProjectField
          ? (option: any) => (
              <div>
                <span>{option.name}</span>

                {isClientShowInProject && option.client && (
                  <span style={{fontStyle: 'italic'}}>
                    {' '}
                    ({option.client.vFirstName} {option.client.vLastName})
                  </span>
                )}

                {isResourceNeedToShow && option.vResourceNeed && (
                  <span style={{fontStyle: 'italic'}}>
                    &nbsp;- {option.vResourceNeed === 'Fixed-Price Contract' ? 'Fixed' : 'T&M'}
                  </span>
                )}
              </div>
            )
          : formatOptionLabel
      }
    />
  )
}

export {SelectSearchField, customStyle}
